<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>

export default {
  created () {
    document.body.classList.add('small-navigation')
  }
}
</script>
